import * as React from "react";
import { ScrollView } from "react-native";
import { useTheme } from "react-native-paper";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import ScreenNameType from "@navigation/nav-screens";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import ConfirmOTP from "app/shared/components/otp/otp";
import { fetchPaymentCardAuthorizationRequest, setPaymentCardStore } from "../reducer/actions";
import { getPaymentCardStoreSelector } from "../reducer/selectors";
import { ServiceCode } from "app/shared/services/api-path";
import { setCardStore } from "../../reducer/actions";
import { getCardStoreSelector } from "../../reducer/selectors";
import StackParamsList from "app/navigation/nav-stack-params";
import { pushAppFlyer } from "app/shared/util/app-flyer";
import { Constant } from "app/shared/constant/constant";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.PAYMENT_CARD_AUTH>;

const PaymentCardAuth = () => {
  const { colors } = useTheme();
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const dispatchStore = useDispatch();

  const routeProps = useRoute<ProfileScreenRouteProp>();

  const [preScreen, setPreScreen] = React.useState<string>(t("CARD_DICH_VU_THE"));

  const onPressGoBack = () => {
    if (routeProps?.params?.preScreen === ScreenNameType.LIST_PAYMENTS) dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
    else dispatch(StackActions.replace(ScreenNameType.LIST_CARDS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: preScreen,
      onPressSubtitle: () => onPressGoBack(),
    },
    {
      name: t("CARD_THANH_TOAN_THE_TIN_DUNG"),
      onPressSubtitle: () => {},
    },
  ];

  const paymentCardStore = useSelector(getPaymentCardStoreSelector);
  const cardStore = useSelector(getCardStoreSelector);

  const onPressCancel = () => {
    const { eventName, params } = handlerParamsAppFlyer(false);
    pushAppFlyer(eventName, params);
    dispatchStore(setPaymentCardStore({ ...paymentCardStore, isCreated: false, isConfirm: false, errorOTP: false }));
    dispatchStore(setCardStore({ ...cardStore, resCardDetail: undefined }));
    dispatch(StackActions.replace(ScreenNameType.PAYMENT_CARD_CREATE, { resetData: true }));
  };

  const onSubmit = ({ otpCode = "" }) => {
    dispatchStore(fetchPaymentCardAuthorizationRequest(paymentCardStore.responseConfirm, otpCode));
  };

  const handlerParamsAppFlyer = (success: boolean) => {
    console.log("handlerParamsAppFlyer");
    const param = {
      //personal_payment, payment_to_others, card_number, account_name, payment_option, amount
      personal_payment:
        paymentCardStore.dataCreate?.TYPE === Constant.CARD.CARD_PAYMENT_TYPE.CRD ? paymentCardStore.dataCreate?.CARD?.embossName : "",
      payment_to_others:
        paymentCardStore.dataCreate?.TYPE === Constant.CARD.CARD_PAYMENT_TYPE.ACT
          ? paymentCardStore.responseCreate?.destinationCardName
          : "",
      card_number: paymentCardStore.dataCreate?.CARD?.cardNum,
      account_name: paymentCardStore.dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNAME,
      payment_option: paymentCardStore.dataCreate?.PAYMENT_TYPE,
      amount: paymentCardStore.dataCreate?.AMOUNT,
    };
    const paramStatus = {
      success: success,
      failure: !success,
    };
    return {
      eventName: "af_pay_card",
      params: {
        af_channel: "ib_rb",
        af_pay_card_info: JSON.stringify(param),
        af_pay_card_status: JSON.stringify(paramStatus),
      },
    };
  };

  React.useEffect(() => {
    if (paymentCardStore.isAuthorization) {
      const { eventName, params } = handlerParamsAppFlyer(true);
      pushAppFlyer(eventName, params);
      dispatch(StackActions.replace(ScreenNameType.PAYMENT_CARD_SUCCESS, { preScreen: routeProps?.params?.preScreen }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, paymentCardStore.isAuthorization, routeProps?.params?.preScreen]);

  React.useEffect(() => {
    if (paymentCardStore.errorOTP === true) {
      const { eventName, params } = handlerParamsAppFlyer(false);
      pushAppFlyer(eventName, params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentCardStore.errorOTP]);

  React.useEffect(() => {
    if (routeProps?.params?.preScreen) {
      const value = routeProps?.params?.preScreen === ScreenNameType.LIST_PAYMENTS ? t("FUNC_DV_THANH_TOAN") : t("CARD_DICH_VU_THE");
      setPreScreen(value);
    }
  }, [routeProps?.params?.preScreen, t]);

  return (
    <Block flex={1} bg={colors.surface}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("CARD_THANH_TOAN_THE_TIN_DUNG")} subtitles={subtitlesArrays} />
        <StepProcessUniversal currentSteps={2} />
        <ConfirmOTP
          goBack={onPressCancel}
          onSubmit={onSubmit}
          isReset={paymentCardStore.isAuthorization}
          errorEndOTP={paymentCardStore.errorOTP}
          serviceCode={ServiceCode.CARD}
          verification={paymentCardStore.responseConfirm}
        />
      </ScrollView>
    </Block>
  );
};
export default PaymentCardAuth;
